import { render, staticRenderFns } from "./HelpItem.vue?vue&type=template&id=fe4c2cbc&scoped=true"
import script from "./HelpItem.vue?vue&type=script&lang=js"
export * from "./HelpItem.vue?vue&type=script&lang=js"
import style0 from "./HelpItem.vue?vue&type=style&index=0&id=fe4c2cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4c2cbc",
  null
  
)

export default component.exports